import GalleryCardCarousel from 'components/ProductPage/GalleryCardCarousel/GalleryCardCarousel';

export default GalleryCardCarousel;
